import { EcleticaCatalog, EcleticaProductTypes } from "@/core/EcleticaCatalog";
import styles from "@/styles/containers/command.module.scss";
import { Currency } from "@/tools";

const EcleticaItem = ({ product, cartItemIndex }) => {
  const getSubItemsOverview = () => {
    return (
      <>
        {product.sub_items
          .map((subItem, index) => `${subItem.qtde}x ${subItem.descr_item}`)
          .join(", ")}
      </>
    );
  };

  return (
    <tr>
      <td>
        <p>{product.qtde}x</p>
      </td>
      <td className="d-flex align-center">
        <div className="d-flex flex-col align-start">
          <p>{product?.descr_item}</p>
          {product.sub_items.length > 0 && (
            <div className="d-flex">{getSubItemsOverview()}</div>
          )}
        </div>
      </td>

      <td className={styles.total}>
        {Currency.formatCurrency(product.vlr_total || product.vlr_unit)}
      </td>
    </tr>
  );
};

export default function EcleticaCartItem({ items }) {
  const groupEcleticaProduct = (productItems) => {
    if (productItems.length === 1) {
      return {
        ...productItems[0],
        sub_items: [],
      };
    }

    const groupedItems = {
      cod_item: 0,
      cod_reg: 0,
      descr_item: "",
      qtde: 0,
      vlr_unit: 0,
      sub_items: [],
    };

    const getEcleticaProductTotalPrice = (mainItem, anotherItems) => {
      return (
        mainItem.qtde * mainItem.vlr_unit +
        anotherItems.reduce(
          (total, item) => total + item.vlr_unit * item.qtde,
          0
        )
      );
    };

    const formatEcleticaProductItems = (productItems) => {
      let mainItem = null;
      let anotherItems = null;

      const comboProducts = productItems.filter(
        (item) => item.type === EcleticaProductTypes.COMBINATION
      );
      const pizzaProducts = productItems.filter(
        (item) => item.type === EcleticaProductTypes.PIZZA
      );

      if (comboProducts?.length > 0) {
        anotherItems = productItems.filter(
          (item) => item.type !== EcleticaProductTypes.COMBINATION
        );
        if (comboProducts.length > 1) {
          comboProducts.sort((a, b) => a.vlr_unit - b.vlr_unit);
          for (let i = 0; i < comboProducts.length - 1; i++) {
            anotherItems.push(comboProducts.pop());
          }
        }
        mainItem = comboProducts[0];
      } else if (pizzaProducts?.length > 0) {
        mainItem = pizzaProducts[0];
        anotherItems = productItems.filter(
          (item) => item.cod_item !== mainItem.cod_item
        );
      } else {
        mainItem = productItems.slice(0, 1)[0];
        anotherItems = productItems.slice(1);
      }

      return { mainItem, anotherItems };
    };

    const { mainItem, anotherItems } = formatEcleticaProductItems(productItems);

    groupedItems.cod_item = mainItem.cod_item;
    groupedItems.cod_reg = mainItem.cod_reg;
    groupedItems.descr_item = mainItem.descr_item;
    groupedItems.qtde = mainItem.qtde;
    groupedItems.vlr_unit = getEcleticaProductTotalPrice(
      mainItem,
      anotherItems
    );
    groupedItems.sub_items = anotherItems;

    return groupedItems;
  };

  const groupProductsByCodReg = () => {
    const productsByCodReg = {};

    items.map((product) => {
      const codReg = product.cod_reg;
      if (!productsByCodReg[codReg]) {
        productsByCodReg[codReg] = [
          {
            ...product,
            type: EcleticaCatalog.getProductType(product.cod_item),
          },
        ];
      } else {
        productsByCodReg[codReg].push({
          ...product,
          type: EcleticaCatalog.getProductType(product.cod_item),
        });
      }
    });

    const groupedProducts = Object.keys(productsByCodReg).map((cod_reg) => {
      return groupEcleticaProduct(productsByCodReg[cod_reg]);
    });

    return groupedProducts;
  };

  return (
    <div className={styles.table}>
      <table>
        <tbody>
          {groupProductsByCodReg().map((item, index) => (
            <EcleticaItem
              key={`cart-item-${Math.random()}`}
              product={item}
              cartItemIndex={index}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
